import { render, staticRenderFns } from "./list_add.vue?vue&type=template&id=0716eb8c&scoped=true"
import script from "./list_add.vue?vue&type=script&lang=js"
export * from "./list_add.vue?vue&type=script&lang=js"
import style0 from "./list_add.vue?vue&type=style&index=0&id=0716eb8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716eb8c",
  null
  
)

export default component.exports